import { useEffect } from 'react';

import { addScript } from '../utils';

const scriptMap: string[] = [];

//https://elvanco.com/blog/how-to-dynamically-load-a-javascript-file-in-react
export function useEffectAddScript(src: string) {
  useEffect(() => {
    return addScript(src);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

//https://elvanco.com/blog/how-to-dynamically-load-a-javascript-file-in-react
export function useEffectAddScriptOnce(src: string) {
  useEffect(() => {
    //debugger
    if (!scriptMap.includes(src)) {
      scriptMap.push(src);
      addScript(src);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export function useEffectOnceAsync<T>(
  effect: () => Promise<T>,
  callback?: (value: T) => void,
) {
  return useEffect(() => {
    async function outer() {
      const response = await effect();

      if (callback) callback(response);
    }

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    outer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
